import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import KuaiShouPage from './pages/kuaiShouPage';
import SearchOrderPage from './pages/searchOrder';

export default function IndexPage() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<KuaiShouPage />} />
        <Route path="/searchorder" element={<SearchOrderPage />} />
      </Routes>
    </BrowserRouter>
  );
}
